import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../images/think-loading.gif';
import _imports_1 from '../images/reload.png';
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "inline-flex loading-box items-center"
};
const _hoisted_3 = {
  key: 1,
  class: "fold-box"
};
const _hoisted_4 = {
  class: "fold-top flex justify-between items-center"
};
const _hoisted_5 = {
  key: 0,
  class: "w-3 h-3 think-loading"
};
const _hoisted_6 = {
  key: 1,
  class: "w-3 h-3 think-loading"
};
const _hoisted_7 = {
  class: "name ml-1"
};
const _hoisted_8 = {
  class: "title flex-1 overflow-hidden px-6 flex justify-center"
};
const _hoisted_9 = {
  class: "pt-3"
};
import { ref, onUnmounted, onMounted } from 'vue';
import { SuccessFilled } from '@element-plus/icons-vue';
import { setFoldFunc, removeFoldFunc } from '@views/main/states/fold.state';
export default /*@__PURE__*/_defineComponent({
  __name: 'FoldBox',
  props: {
    id: {},
    status: {},
    title: {},
    loading: {
      type: Boolean
    },
    showDownIcon: {
      type: Boolean,
      default: true
    }
  },
  emits: ["change", "restart"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const statusMap = {
      1: '任务进行中',
      3: '已完成',
      2: '重新生成'
    };
    const isFold = ref(false);
    const toggleFold = bol => {
      isFold.value = bol;
      emits('change', isFold.value);
    };
    const handleRestart = () => {
      if (props.status === 2) emits('restart', true);
    };
    onUnmounted(() => {
      if (props.id) removeFoldFunc(props.id);
    });
    onMounted(() => {
      if (props.id) setFoldFunc(props.id, toggleFold);
    });
    __expose({
      isFold,
      setIsFold: val => {
        isFold.value = val;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_i_home_down = _resolveComponent("i-home-down");
      return __props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        alt: "思考"
      }, null, -1)), _renderSlot(_ctx.$slots, "loading", {}, () => [_cache[1] || (_cache[1] = _createTextVNode("思考中...", -1))]), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "load-more ml-[2px]"
      }, null, -1))])])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: _normalizeClass(["status", {
          're-start': __props.status === 2
        }]),
        onClick: handleRestart
      }, [__props.status === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[4] || (_cache[4] = [_createElementVNode("img", {
        src: _imports_0,
        alt: "思考",
        class: "think"
      }, null, -1)]))])) : _createCommentVNode("", true), __props.status === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[5] || (_cache[5] = [_createElementVNode("img", {
        src: _imports_1,
        alt: "重新"
      }, null, -1)]))])) : __props.status === 3 ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 2,
        color: "#03B33F"
      }, {
        default: _withCtx(() => [_createVNode(_unref(SuccessFilled))]),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_7, _toDisplayString(statusMap[__props.status]), 1)], 2), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        class: _normalizeClass(["animate-sty1 truncate relative", {
          animate: !isFold.value && __props.status === 1
        }])
      }, [_renderSlot(_ctx.$slots, "title", {}, () => [_createTextVNode(_toDisplayString(__props.title), 1)])], 2)]), __props.showDownIcon ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        class: _normalizeClass(["icon-down cursor-pointer text-[9px]", {
          'rotate-180': isFold.value
        }]),
        color: "#4E5969",
        onClick: _cache[0] || (_cache[0] = $event => toggleFold(!isFold.value))
      }, {
        default: _withCtx(() => [_createVNode(_component_i_home_down)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: _normalizeClass(["fold-content", {
          'is-fold': isFold.value
        }])
      }, [_createElementVNode("div", _hoisted_9, [_renderSlot(_ctx.$slots, "default", {
        isFold: isFold.value
      })])], 2)]));
    };
  }
});